import { useEffect, useState } from 'react';
import { useOutletContext, Outlet } from 'react-router-dom';
import { useQueryState, IconLoader, Filters } from '@ui/src';
import { useAppDispatch, useAppSelector } from '@store';
import {
  getCardsTransactions,
  onFilterCardsTransactionsList,
  clearAccountsTransactionState,
} from '../store/slices/statements';
import { overviewCardsSchema } from '../variables/overview-cards';
import OverviewStatementsCardsTransaction from '../../../components/partial/overview-statements/overview-statements-cards-transaction';
import { CustomerType, StatementsContextType } from '../types';

import cn from '../customers.module.css';

const OverviewStatementsCards = ({
  customerType,
}: {
  customerType: CustomerType;
}) => {
  const { cards } = useOutletContext<StatementsContextType>();

  const [cardId, setCardId] = useState('');

  const dispatch = useAppDispatch();

  const { cardsTransactions } = useAppSelector(
    (state) => state.customerStatements,
  );

  const { filters, sort, onFilterChange } = useQueryState(overviewCardsSchema);

  const onFilter = (values: Filters) => {
    const body = { ...values };

    onFilterChange(values);

    if (values.date) {
      body.date.value = values.date.value?.map((item) =>
        new Date(item).toISOString(),
      );
    }

    dispatch(onFilterCardsTransactionsList(body));
  };

  useEffect(() => {
    if (!cardId && cards && cards.length) {
      setCardId(cards[0]);
    }
  }, [cardId, cards]);

  useEffect(() => {
    dispatch(clearAccountsTransactionState());
  }, [dispatch]);

  useEffect(() => {
    if (cardId && !cardsTransactions.values) {
      dispatch(
        getCardsTransactions({
          filters,
          cardId,
          customerType,
        }),
      );
    }
  }, [dispatch, cardsTransactions.values, cardId, sort, filters]);

  let content;

  if (cardsTransactions.isLoading) {
    content = (
      <div className={cn.overviewStatementsLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <OverviewStatementsCardsTransaction
        onSort={() => {}}
        onFilter={onFilter}
        cardsTransactions={cardsTransactions.values}
        filters={filters}
        sort={sort}
        requestInProgress={cardsTransactions.requestInProgress}
      />
    );
  }

  return (
    <>
      {cards?.length > 1 && (
        <div className={cn.overviewStatementsAccountsWrapper}>
          {cards.map((item) => (
            <button
              key={item}
              type="button"
              className={`${cn.overviewStatementsAccountButton} ${
                cardId === item ? cn.overviewStatementsAccountButtonActive : ''
              }`}
              onClick={() => {
                setCardId(item);
                dispatch(
                  getCardsTransactions({
                    cardId: item,
                    customerType,
                  }),
                );
              }}
            >
              {item}
            </button>
          ))}
        </div>
      )}
      <div className={cn.overviewStatementsContentTable}>{content}</div>
      <Outlet />
    </>
  );
};

export default OverviewStatementsCards;
